import { PathTaskFormatter } from './functions/path_task_formatter_fn';
import { TaskUpdateFunction } from './functions/task_update_fn';
import { IntakeService } from './services/intake_question_service';
import { IntakeStatusService } from './services/intake_status_service';
import { TodosContentService } from './services/my_todos_content_service';
import { PathTitleColorService } from './services/path_color_service';
import { PathTaskUpdateService } from './services/path_task_update_service';
import { PathToggleService } from './services/path_toggle_service';
import { PathDetailLocationService } from './services/task_detail_location_service';
import { TodoDateRangeService } from './services/todo_date_range_service';
import { TodoRefreshService } from './services/todo_refresh_service';

require('angular-ui-router');
import 'utility-ng-interface';
import 'utility-ng-enumeration';
import 'utility-ng-configuration';
import 'utility-ng-time';
import 'utility-ng-network-cache';
import 'data-ng-path-item';

angular
  .module('data-ng-todos', [
    'utility-ng-time',
    'utility-ng-interface',
    'utility-ng-enumeration',
    'utility-ng-configuration',
    'utility-ng-network-cache',
    'data-ng-path-item'
  ])
  .service('ngPathTaskFormatter', PathTaskFormatter)
  .service('pathDetailLocationService', PathDetailLocationService)
  .service('ngPathToggleService', PathToggleService)
  .service('pathTitleColorService', PathTitleColorService)
  .service('ngTodoDateRangeService', TodoDateRangeService)
  .service('ngPathTaskUpdateService', PathTaskUpdateService)
  .service('ngTodosContentService', TodosContentService)
  .service('ngTodoRefreshService', TodoRefreshService)
  .service('ngIntakeStatusService', IntakeStatusService)
  .service('ngIntakeService', IntakeService)
  .service('taskUpdateFn', TaskUpdateFunction);

module.exports = 'data-ng-todos';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/main.ts